export default "__VITE_ASSET__Cne$$q2d__";